import type { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { TRANSFER_ANIMATIONS } from './transfer-animations';

type Props = PropsWithChildren<{
  visible: boolean;
  className?: string;
}>;

/**
 * The LabelReveal component transitions its children with a fade in.
 */
export function LabelReveal({ children, visible, className }: Props) {
  return (
    <StyledLabel
      className={className}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(50%)',
      }}
    >
      {children}
    </StyledLabel>
  );
}

const StyledLabel = styled.div`
  transition-duration: ${TRANSFER_ANIMATIONS.duration}ms;
  transition-property: opacity, transform;
  transition-timing-function: ${TRANSFER_ANIMATIONS.ease};
  will-change: transform;
`;
